export const API_URL = 'https://api.dhtech.ae/' 